module.exports = __webpack_public_path__ + "static/media/logoBg.0ece8af5.webp";